<template>
  <div class="app-pagination" ref="pagination">
    <div v-if="flag">
      <!-- {{counter}} -->
      <div class="arrow left"
        :class="counter == 1 ? 'inactive' : ''"
        @click="toLeft"
      >
      </div>
      <div class="pag-content">
        <div :class="counter == 1 ? 'active' : ''"
          @click="counter = 1"
        >
          1
        </div>
        <div v-if="lengthPage > 2 && rangeStart > 2"
          @click="rangeLeft"
        >
          ...
        </div>

        <div v-for="i in rangeOut" :key="i"
          :class="counter == i ? 'active' : ''"
          @click="counter = i"
        >
          {{i}}
        </div>

        <div v-if="lengthPage > 6 && rangeEnd < lengthPage - 1"
          @click="rangeRight"
        >
          ...
        </div>
        <div :class="counter == lengthPage ? 'active' : ''"
          @click="counter = lengthPage"
          v-if="lengthPage > 1"
        >
          {{lengthPage}}
        </div>
      </div>
      <div class="arrow right"
        :class="counter == lengthPage ? 'inactive' : ''"
        @click="toRight"
      >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      validator: function(value){
        var regTemplate = /\{id\}/;
        var regArray = regTemplate.exec(value);

        if (regArray) {
          return true;
        } else {
          return false;
        }
      }
    },
    length: {
      type: Number
    },
    start: {
      type: Number,
      default: 0
    },
    event: {
      type: Boolean,
      default: false
    },
    options: Object,
    take: Number,
    perPage: Number
  },
  data () {
    return {
      range: [],
      rangeStart: false,
      rangeEng: false,
      counter: false,
      flag: false,
      step: false,
      link_flag: false,
      lengthPage: false
    }
  },
  mounted () {
    this.createParams();

    setTimeout(() => {
      this.createParams();
    }, 2000);
  },
  computed: {
    rangeOut () {
      if (this.lengthPage > 2) {
        return [...this.createRange(this.rangeStart, this.rangeEnd)];
      } else {
        return [];
      }
    }
  },
  methods: {
    createRange: function* (start, end) {
      // console.log(start, end);
      end = end - 1; //костыль
      for (let i = start; i < (end); i++) {
          yield i;
      }
      yield end;
      yield end + 1;
    },
    createParams: function () {
      if (this.length != null) {
        this.lengthPage = this.length;
      } else {
        this.lengthPage = Math.ceil(this.perPage/this.take);
      }

      if ( this.lengthPage > 0) {
        this.counter = this.start == 0 ? 1 : this.start;

        const el = this.$refs['pagination'];
        if (el) {
          var blockData = el.getBoundingClientRect();
          this.step = Math.round((blockData.width - 160) / 30) - 1;
        } else {
          this.step = 4;
        }

        this.normalParams();

        this.flag = true;
      }
    },
    toLink: function () {

      if (!this.event && this.link) {
        var path = this.link;

        path = path.replace('{id}', this.counter - 1);
        if (this.options) {
          for (var key in this.options) {
            path = path.replace(`{${key}}`, this.options[key]);
          }
        }

        if (this.link_flag) {
          this.$router.push({ path: path });
        } else {
          this.link_flag = true;
        }
      } else {
        if (this.link_flag) {
          this.$emit('pagEvent', this.counter - 1);
        } else {
          this.link_flag = true;
        }
      }
    },
    toLeft: function () {
      if (this.counter > 1) {
        this.counter--;

        if (this.rangeStart > 2) {
          if (this.counter == this.rangeStart) {
            this.rangeStart--;
            this.rangeEnd--;
          } else {
            this.normalParams();
          }
        }
      }
    },
    toRight: function () {
      if (this.counter < this.lengthPage) {
        this.counter++;

        if (this.rangeEnd < this.lengthPage-1) {
          if (this.counter == this.rangeEnd) {
            this.rangeStart++;
            this.rangeEnd++;
          } else {
            this.normalParams();
          }
        }
      }
    },
    rangeLeft: function () {
      if (this.rangeStart > 2) {
        if (this.rangeStart - this.step > 2) {
          this.rangeStart -= this.step;
          this.rangeEnd -= this.step;
        } else {
          this.rangeStart = 2;
          this.rangeEnd = this.step + this.rangeStart;
        }
      }
    },
    rangeRight: function () {
      if (this.rangeEnd < this.lengthPage-1) {
        if (this.rangeEnd + this.step < this.lengthPage-1) {
          this.rangeStart += this.step;
          this.rangeEnd += this.step;
        } else {
          this.rangeStart = this.lengthPage - this.step - 1;
          this.rangeEnd = this.step + this.rangeStart;
        }
      }
    },
    normalParams: function () {
      if (this.lengthPage <= this.step + 3 ) {
        this.rangeStart = 2;
        this.rangeEnd = this.lengthPage - 1;
      } else {
        if (this.counter < this.step + 2) {
          this.rangeStart = 2;
        } else if (this.counter + this.step < this.lengthPage) {
          this.rangeStart = this.counter - 1;
        } else {
          this.rangeStart = this.lengthPage - this.step - 1;
        }

        this.rangeEnd = this.rangeStart + this.step;
      }
    }
  },
  watch: {
    counter: function (val) {
      if (val == 1 || val == this.lengthPage) {
        this.normalParams();
      }
      this.toLink();
    },
    length: function (val) {
      this.createParams();
    }
  }
}
</script>

<style lang="scss" scoped>
  .app-pagination {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    font-size: 14px;

    &>div {
      width: 100%;
      height: 42px;
      border: solid 1px rgba(76, 80, 86, 0.1);
      overflow: hidden;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      div {
        cursor: pointer;
        user-select: none;
      }

      .pag-content {
        width: calc(100% - 50px);
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        div {
          margin: 0 5px;
        }
      }

      .active {
        background: $mainGreen;
        color: white;
        font-weight: 500;
        padding: 7px 10px;
        border-radius: 5px;
      }

      .arrow {
        width: 25px;
        height: 100%;
        background: $mainGreen;
        position: relative;

        &:before {
          content: '';
          position: absolute;
          display: block;
          width: 0;
          height: 0;
          border-top: 5px solid transparent;
          border-bottom: 5px solid transparent;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }

        &.left:before {
          border-right: 10px solid white;
        }

        &.right:before {
          border-left: 10px solid white;
        }

        &.inactive {
          cursor: default;
          background: #BEBEBE;
        }
      }
    }
  }
</style>
